import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@fry/lib/guards';

import { UserFieldsComponent } from '@fry/components/user-fields/user-fields/user-fields.component';
import { UserFieldListComponent } from '@fry/components/user-fields/user-field-list/user-field-list.component';
import { UserFieldAddComponent } from '@fry/components/user-fields/user-field-add/user-field-add.component';
import { UserFieldEditComponent } from '@fry/components/user-fields/user-field-edit/user-field-edit.component';
import { UserFieldEditResolver } from '@fry/components/user-fields/user-field-edit/user-field-edit.resolver';


const routes: Routes = [
  {
    path: '',
    component: UserFieldsComponent,
    canActivate: [
      AuthGuard,
    ],
    data: {
      requiredPermissions: ['userFields.view']
    },
    children: [
      {
        path: '',
        component: UserFieldListComponent,
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'add',
        component: UserFieldAddComponent,
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: ':id/edit',
        component: UserFieldEditComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          userField: UserFieldEditResolver
        }
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    UserFieldEditResolver
  ]
})
export class UserFieldsRoutingModule { }
